/* eslint-disable no-plusplus */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable func-names */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint-disable no-alert */
import qs from 'qs';
import * as constType from '../constants/actionsTypes';
import {
  apiPostMemberLogin,
  apiPostRegisterPhoneValiCode,
  apiDoMemberRegister,
  getSentModifyPwOTP,
  getDoMemberPasswordModify,
} from './testJsonApi';

const memberMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    // 登入頁
    case 'MID_SUBMIT_LOGIN_DATA': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      store.dispatch({
        type: constType.CHANGE_MODAL_SHOW,
        payload: true,
      });

      const isThirdPartyLoginPage = window.location.href.toUpperCase().indexOf('THIRDPARTYLOGIN') !== -1;

      const request = {
        loginName: action.payload.account,
        loginPW: action.payload.password,
        backUrl: action.payload.backUrl,
        CSRFToken: action.payload.CSRFToken,
        // alreadyMember,
        // googleResponse,
      };

      const postRequest = qs.stringify(request);
      apiPostMemberLogin('post', postRequest)
        .then((res) => {
          // const rtnObj = JSON.parse(res.data);
          const rtnObj = res.data;
          const rtnCode = parseInt(rtnObj.rtnCode, 10);
          const { rtnMsg, goUrl } = rtnObj;

          const rtnEmailMD5 = rtnObj.emailMD5;
          const rtnEmailSHA = rtnObj.emailSHA;

          const rtnCouponMessage = rtnObj.messages ? rtnObj.messages : [];
          const rtnBonusMessage = rtnObj.bonusMessage ? rtnObj.bonusMessage : [];

          let redirectURL = '';

          if (navigator.userAgent.toLowerCase().indexOf('2020specialeccart') !== -1) {
            store.dispatch({
              type: constType.CHANGE_EFFECT_ISLOADING,
              payload: false,
            });
            store.dispatch({
              type: constType.CHANGE_MODAL_SHOW,
              payload: false,
            });
            // alert('如您須購買及相關服務請洽詢現場門市人員。謝謝!');
            store.dispatch({
              type: constType.UPDATE_API_RESPONSE_MESSAGE,
              payload: '如您須購買及相關服務請洽詢現場門市人員。謝謝!',
            });
            store.dispatch({
              type: constType.SHOW_EXCEPTION_MODAL,
              payload: true,
            });
            window.location.href = '/';
            return false;
          }

          if (isThirdPartyLoginPage) {
            if (memberLoginFrom.alreadyMember.value === '') {
              store.dispatch({
                type: constType.CHANGE_EFFECT_ISLOADING,
                payload: false,
              });
              store.dispatch({
                type: constType.CHANGE_MODAL_SHOW,
                payload: false,
              });
              // alert('請先選擇是否已為會員');
              store.dispatch({
                type: constType.UPDATE_API_RESPONSE_MESSAGE,
                payload: '請先選擇是否已為會員!',
              });
              store.dispatch({
                type: constType.SHOW_EXCEPTION_MODAL,
                payload: true,
              });
              return false;
            }

            if (memberLoginFrom.alreadyMember.value === '0') {
              store.dispatch({
                type: constType.CHANGE_EFFECT_ISLOADING,
                payload: false,
              });
              store.dispatch({
                type: constType.CHANGE_MODAL_SHOW,
                payload: false,
              });
              // alert('頁面將導至會員註冊頁面，敬請註冊會員即可綁定帳號');
              store.dispatch({
                type: constType.UPDATE_API_RESPONSE_MESSAGE,
                payload: '頁面將導至會員註冊頁面，敬請註冊會員即可綁定帳號!',
              });
              store.dispatch({
                type: constType.SHOW_EXCEPTION_MODAL,
                payload: true,
              });
              window.location.href = '/memberRegister';
              return false;
            }
          }

          if (rtnCode === 1 || rtnCode === 2) {
            if (rtnObj.isPasswordModify) {
              store.dispatch({
                type: constType.CHANGE_EFFECT_ISLOADING,
                payload: false,
              });
              store.dispatch({
                type: constType.CHANGE_MODAL_SHOW,
                payload: false,
              });
              // alert(rtnMsg);
              store.dispatch({
                type: constType.UPDATE_API_RESPONSE_MESSAGE,
                payload: rtnMsg,
              });
              store.dispatch({
                type: constType.SHOW_EXCEPTION_MODAL,
                payload: true,
              });
            }

            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
              event: 'userLogin',
              // sitetype: dataLayerSiteType,  // dataLayerSiteType 未定義？來自？
              emailMD5: rtnEmailMD5, // 動態產生
              emailSHA: rtnEmailSHA, // 動態產生
              brand: '正和', // 依照所在產品線不同去送出值 ex.特力屋/正和/HOLA
            });

            if (rtnMsg === '密碼超過半年未更動') {
              const yes = window.confirm(
                '超過半年未變更密碼，為保障您的帳號安全，建議您更換密碼。\n按下確定前往變更？',
              );

              if (yes) {
                window.location.href = '/memberModify/memberPasswordModify';
              } else {
                $.ajax({
                  url: '/memberLogin/CancelPw',
                  type: 'GET',
                  success(json) {
                    window.location.href = '/';
                  },
                  error(e) {

                  },
                });
              }
            } else if (rtnCouponMessage.length === 0 && rtnBonusMessage.length === 0) {
              window.location.href = goUrl;
            } else {
              if (rtnCouponMessage.length > 0) {
                const sHtml = [];
                for (let i = 0, j = rtnCouponMessage.length; i < j; i++) {
                  if (rtnCouponMessage[i] !== '') {
                    sHtml[sHtml.length] = `<li>${rtnCouponMessage[i]}</li>`;
                  }
                }
              }

              if (rtnBonusMessage.length > 0) {
                const sHtml = [];
                for (let i = 0, j = rtnBonusMessage.length; i < j; i++) {
                  if (rtnBonusMessage[i] !== '') {
                    sHtml[sHtml.length] = `<li>${rtnBonusMessage[i]}</li>`;
                  }
                }
              }

              redirectURL = goUrl;
              if (redirectURL !== '') {
                window.location.href = redirectURL;
              }
            }
          } else {
            store.dispatch({
              type: constType.CHANGE_EFFECT_ISLOADING,
              payload: false,
            });
            store.dispatch({
              type: constType.CHANGE_MODAL_SHOW,
              payload: false,
            });
            // alert(rtnMsg);
            store.dispatch({
              type: constType.UPDATE_API_RESPONSE_MESSAGE,
              payload: rtnMsg,
            });
            store.dispatch({
              type: constType.SHOW_EXCEPTION_MODAL,
              payload: true,
            });
          }
        }).catch((err) => {
          // alert('目前系統忙碌中，請稍後再試！');

          store.dispatch({
            type: constType.CHANGE_EFFECT_ISLOADING,
            payload: false,
          });
          store.dispatch({
            type: constType.CHANGE_MODAL_SHOW,
            payload: false,
          });
          store.dispatch({
            type: constType.UPDATE_API_RESPONSE_MESSAGE,
            payload: '目前系統忙碌中，請稍後再試！',
          });
          store.dispatch({
            type: constType.SHOW_EXCEPTION_MODAL,
            payload: true,
          });
        });
      return next(action);
    }
    // 註冊頁
    case 'MID_SUBMIT_REGISTER_DATA': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });

      const {
        name,
        birthYear,
        birthMonth,
        birthDate,
        gender,
        phoneNumber,
        phoneToken,
        captchaNum,
        CSRFToken,
      } = action.payload;

      const request = {
        registerName: name,
        YYYY: birthYear,
        MM: birthMonth,
        DD: birthDate,
        registerSex: gender,
        registerPhone: phoneNumber,
        loginValiCode: phoneToken,
        registerValiCode: captchaNum,
        CSRFToken,
      };

      const postRequest = qs.stringify(request);
      apiDoMemberRegister('post', postRequest)
        .then((res) => {
          // const rtnObj = JSON.parse(res.data);
          const rtnObj = res.data;
          const rtnCode = parseInt(rtnObj.rtnCode, 10);
          const { rtnMsg } = rtnObj;
          const { goUrl } = rtnObj;
          if (rtnCode === 1) {
            // 導至註冊成功頁
            window.location.href = goUrl;
          } else if (rtnCode === -2) {
            alert(rtnMsg);
          } else {
            alert(rtnMsg);
          }
          store.dispatch({
            type: constType.CHANGE_EFFECT_ISLOADING,
            payload: false,
          });
        })
        .catch((err) => {
          store.dispatch({
            type: constType.CHANGE_EFFECT_ISLOADING,
            payload: false,
          });
        });
      return next(action);
    }
    // 獲取手機驗證碼
    case 'MID_GET_PHONE_CODE': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });

      const {
        name,
        birthYear,
        birthMonth,
        birthDate,
        phoneNumber,
        CSRFToken,
      } = action.payload;
      const birthday = birthYear + birthMonth.padStart(2, '0') + birthDate.padStart(2, '0');

      const request = {
        phoneNumber,
        birthday,
        name,
        memberID: '',
        CSRFToken,
      };

      const postRequest = qs.stringify(request);
      apiPostRegisterPhoneValiCode('post', postRequest)
        .then((res) => {
          // const rtnObj = JSON.parse(res.data);
          const rtnObj = res.data;
          const rtnCode = parseInt(rtnObj.rtnCode, 10);
          const { rtnMsg } = rtnObj;

          if (rtnCode === 1) {
            alert(`手機驗證碼已發送至${phoneNumber}`);
            store.dispatch({
              type: constType.GET_PHONE_CODE,
              payload: true,
            });
          } else {
            alert(rtnMsg);
            store.dispatch({
              type: constType.GET_PHONE_CODE,
              payload: false,
            });
          }
          store.dispatch({
            type: constType.CHANGE_EFFECT_ISLOADING,
            payload: false,
          });
        })
        .catch((err) => {
          alert(err);
          store.dispatch({
            type: constType.GET_PHONE_CODE,
            payload: false,
          });
          store.dispatch({
            type: constType.CHANGE_EFFECT_ISLOADING,
            payload: false,
          });
        });

      // test 用
      // store.dispatch({
      //   type: constType.GET_PHONE_CODE,
      //   payload: true,
      // });

      return next(action);
    }

    case 'MID_GET_PW_CODE':
      getSentModifyPwOTP('post', action.payload)
        .then((res) => {
          const rtnObj = JSON.parse(res);
          const rtnCode = parseInt(rtnObj.rtnCode);
          const { rtnMsg } = rtnObj;

          if (rtnCode === 1) {
            alert('手機驗證碼已發送');
          } else {
            alert(rtnMsg);
          }
        })
        .catch((err) => {
          alert(err);
        });
      return next(action);
    case 'MID_SEND_NEW_PW':
      getDoMemberPasswordModify('post', action.payload)
        .then((res) => {
          const rtnObj = JSON.parse(res);
          const rtnCode = parseInt(rtnObj.rtnCode);
          const { rtnMsg } = rtnObj;
          alert(rtnMsg);
          if (rtnCode > 0) {
            // 前往顧客中心
            window.location.href = '/my-account/index';
          }
        })
        .catch((err) => {
          alert(err);
        });
      return next(action);
    default:
      return next(action);
  }
};

export default memberMiddleware;
